var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",class:{ 'logo--dynamic': _vm.changeColorOnMobile }},[_c('svg',{attrs:{"viewBox":"0 0 80 22","preserveAspectRatio":"xMidYMin","xmlns":"http://www.w3.org/2000/svg"}},[_c('text',{attrs:{"y":"20"}},[_vm._v(_vm._s(_vm.$siteName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }